export default __webpack_public_path__ + "static/standardVoucher-9779ed72db21e0c0d8075bb5c3a994d8.png";